module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title "
  }, [_vm._v("Transactions")]), _vm._v(" "), (_vm.showInformationMessage) ? _c('div', {
    staticClass: "panel-body account-notice"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    attrs: {
      "id": "transaction-message"
    }
  }, [_vm._v(_vm._s(_vm.informationMessage))])])]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "modal-subtitle"
  }, [_vm._v("\n            Note number: " + _vm._s(_vm.noteId) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "transaction-table-scroll-wrap"
  }, [_c('div', {
    ref: "tableScroll",
    staticClass: "table-responsive bottom-margin",
    on: {
      "scroll": _vm.onTableScroll
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Transaction type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(t, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(t.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(t.amount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatType(t.type, 'investor', t.fundingSourceId)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.isFailTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (_vm.isCancelTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransaction(t)) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransactionWithSelectedErrorsCode(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (t.status == 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e(), _vm._v(" "), (t.status == 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScrollRightHint),
      expression: "showScrollRightHint"
    }],
    staticClass: "transaction-scroll-right-btn",
    attrs: {
      "type": "button",
      "aria-label": "Scroll table all the way to the right"
    },
    on: {
      "click": _vm.scrollTableToEnd
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5df7ad52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Transaction.vue
// module id = 2157
// module chunks = 1